import { useMutation, useQueryClient } from 'react-query';
import { trpc } from '../../../../lib/trpc';
import { getAdminKeys } from './adminQueries';

const useAddAdmin = () => {
    const queryClient = useQueryClient();

    return useMutation(
        (options: { email: string; role: string; name: string }) => {
            return trpc.MembersApi.addAdminToAccount.query(options);
        },
        {
            onSettled: () => {
                queryClient.invalidateQueries(getAdminKeys.lists());
            },
        },
    );
};

export default useAddAdmin;
